import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const SuperAdminDashboard = () => {

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h4" fontWeight={800} mb={3}>
                Super Admin Panel 🚀
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 3 }}>
                        <Typography variant="h6">Subscription Plans</Typography>
                        <Button
                            component={Link}
                            to="/superadmin/plans"
                            variant="contained"
                            sx={{ mt: 2 }}
                        >
                            Manage Plans
                        </Button>
                    </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 3 }}>
                        <Typography variant="h6">Assign Plans</Typography>
                        <Button
                            component={Link}
                            to="/super-admin/assign"
                            variant="contained"
                            sx={{ mt: 2 }}
                        >
                            Assign Subscription
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SuperAdminDashboard;